import { render } from "./VTaskCard.vue?vue&type=template&id=c3c94c12&ts=true"
import script from "./VTaskCard.vue?vue&type=script&lang=ts"
export * from "./VTaskCard.vue?vue&type=script&lang=ts"

import "./VTaskCard.vue?vue&type=style&index=0&id=c3c94c12&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__